/**
 * Une clases condicionales sin traer una dependencia por 300 bytes.
 *
 * Acepta cualquier valor porque los patrones habituales (`icon && "pl-9"`) devuelven
 * cosas que no son strings: lo que no es texto ni número, se ignora.
 */
export type ClassValue = unknown;

export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const value of values) {
    if (!value) continue;
    if (Array.isArray(value)) {
      const nested = cn(...(value as ClassValue[]));
      if (nested) out.push(nested);
    } else if (typeof value === "string" || typeof value === "number") {
      out.push(String(value));
    }
  }
  return out.join(" ");
}
